<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">书名/id</span>
        <el-input
          v-model="parameter.name"
          class="item_input"
        />
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        type="primary"
        icon="el-icon-circle-plus"
        @click="dialogVisible = true"
      >创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="书籍id"
        />
        <el-table-column
          prop="book_name"
          label="书籍名"
        />
        <el-table-column
          prop="roi_standard"
          label="roi标准"
        />
        <el-table-column label="操作">
          <template scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="modify(scope.row)"
            >修改</el-button>
            <el-button
              type="warning"
              size="mini"
              @click="deleteBooks(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="data.id ? '修改书籍' : '创建书籍'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="(data.name = null),(data.id = null),(data.roi_standard = 1)"
    >
      <div class="content">
        <div class="item">
          <span class="item_title">书籍名称</span>
          <el-input
            v-model="data.name"
            class="item_input"
            :disabled="!!data.id"
          />
        </div>
        <div class="item">
          <span class="item_title">ROI标准</span>
          <el-input-number
            v-model="data.roi_standard"
            :min="1"
            :max="99"
          />
        </div>
        <div class="item">
          <span style="color:#F56C6C"> 注：RIO标准必须是整数，且不能大于100并且不能小于0</span>
        </div>
      </div>
      <div style="display: flex; margin-top: 30px;justify-content: end;">
        <el-button
          type="primary"
          @click="determine"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPlatform, deleteBooks, addBookOwnership, modifyBookOwnership } from '@/api/oceanNovelReport.js'
import { getBookOwnershipList } from '@/api/oceanNovelReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        name: null
      },
      data: {
        name: null,
        id: null,
        roi_standard: 1
      },
      dialogVisible: false,
      lastTimeValue: '', // 存储上一次的值
      platforms: []
    }
  },
  created() {
    this.getDataList()
    this.myGetPlatform()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getBookOwnershipList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.data.name = row.book_name
      this.data.roi_standard = row.roi_standard
      this.data.id = row.id
    },

    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    async determine() {
      let text = null
      if (!this.data.name) {
        text = '请填写名称'
      }
      if (!text) {
        this.data.id ? await modifyBookOwnership(this.data) : await addBookOwnership(this.data)
      }
      this.$message({
        message: text ? '请填写名称' : this.data.id ? '修改成功' : '创建成功',
        type: text ? 'warning' : 'success'
      })
      if (!text) {
        this.data.name = null
        this.data.roi_standard = 1
        this.dialogVisible = false
        this.getDataList()
      }
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    // 重置
    reset() {
      this.parameter.name = null
      this.parameter.page = 1
      this.parameter.page_size = 10
      this.getDataList()
    },
    // 删除
    deleteBooks(row) {
      console.log(row)
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await deleteBooks(row.id)
        this.getDataList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },

    verification(value) {
      if (value) {
        const rex = new RegExp(/^100$|^(\d|[1-9]\d)$/)
        this.data.roi_standard = rex.test(value) ? value : this.lastTimeValue
        this.lastTimeValue = rex.test(value) ? value : this.lastTimeValue
      }
    },

    async myGetPlatform() {
      const data = await getPlatform({ type: 1 })
      this.platforms = data.data.list
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}

.selectionArea {
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    .item_title {
      margin-right: 10px;
      display: inline-block;
    }
    .item_input {
      width: 200px;
    }
  }
}
</style>
